/**
 * Collection Experience – vertical feature accordion
 */
(function () {
  'use strict';

  function initAccordion(root) {
    const items = root.querySelectorAll('[data-cexp-item]');
    if (!items.length) return;

    items.forEach((item) => {
      const trigger = item.querySelector('[data-cexp-trigger]');
      const panel = item.querySelector('[data-cexp-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((other) => {
          const otherTrigger = other.querySelector('[data-cexp-trigger]');
          const otherPanel = other.querySelector('[data-cexp-panel]');
          other.classList.remove('is-open');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function initSection(sectionRoot) {
    const accordion = sectionRoot.querySelector('[data-cexp-accordion]');
    if (accordion && accordion.dataset.cexpReady !== 'true') {
      accordion.dataset.cexpReady = 'true';
      initAccordion(accordion);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-collection-experience]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-collection-experience]');
    if (root) initSection(root);
  });
})();
